import { Component, OnInit } from '@angular/core';
import {BannerBase} from '../banner-base';
import {DialogService} from '../../../../core/services/dialog.service';

@Component({
  selector: 'app-buy-policy-banner',
  templateUrl: './buy-policy-banner.component.html',
  styleUrls: ['./buy-policy-banner.component.scss']
})
export class BuyPolicyBannerComponent extends BannerBase implements OnInit {

  get leftImageSrc(): string {
    return './assets/images/banners/opiekun.svg';
  }

  constructor(public dialogService: DialogService) {
    super(dialogService);
  }

  ngOnInit() {
  }

}
